import { Link } from 'react-router-dom';
import { flattenToAppURL } from '@plone/volto/helpers';
import { TCellComponent } from '../List';

const TitleCellContent: TCellComponent<string> = ({ data, url }) => (
  <Link to={flattenToAppURL(url)}>{data}</Link>
);

export default TitleCellContent;
